/**
 * Catálogo de stock del showroom (contrato API). Orden = leyenda y filtros.
 * Un tenant futuro puede mandar `{ id, label }[]` y mergearse encima;
 * los colores siguen saliendo de `CAD_PARCEL_STOCK_STYLE.stockFill[id]`.
 * @type {{ id: string, label: string }[]}
 */
export const CAD_STOCK_STATUS_ITEMS = [
  { id: 'available', label: 'Disponible' },
  { id: 'reserved', label: 'Reservado' },
  { id: 'sold', label: 'Vendido' },
  { id: 'offer', label: 'En oferta' },
  { id: 'unavailable', label: 'No disponible' },
];

export const CAD_STOCK_STATUSES = CAD_STOCK_STATUS_ITEMS.map((item) => item.id);

/**
 * Clasificador visual del GeoJSON CAD (`properties.attributes.cad_kind`).
 * Calles / verdes / predio no son inventario. Si falta, el feature es un lote.
 */
export const CAD_KINDS = ['lot', 'street', 'green', 'site'];
export const CAD_KIND_DEFAULT = 'lot';

/** Copy del select de tipo en la ficha (Owner / staff). */
export const CAD_KIND_LABELS = {
  lot: 'Lote',
  street: 'Calle',
  green: 'Espacio verde',
  site: 'Predio',
};

/** Máximo de caracteres del título del showroom (`PATCH /updatecadproject`). */
export const CAD_PROJECT_NAME_MAX = 200;

/** Pitch inicial en la vista compartida (`/#/lista/:id`). El panel Listas queda cenital. */
export const CAD_MAP_INITIAL_PITCH = 60;

/** Zoom máximo solo en `/#/lista/:id`. Listas / Referenciar no cambian. */
export const CAD_SHARE_MAX_ZOOM = 19;

/** Puntos de control de georreferencia (`PATCH /updatecadproject`). */
export const CAD_GEOREF_MIN_POINTS = 2;
export const CAD_GEOREF_MAX_POINTS = 3;

/** @deprecated Preferí `LIST_SORT_OPTIONS` de `Map/utils/listSort`. */
export { LIST_SORT_OPTIONS as CAD_SORT_OPTIONS } from '../../Map/utils/listSort';

export const CAD_USES = [
  'residencial',
  'housing',
  'corporativo',
  'comercial',
  'amenity',
  'unknown',
];

export const CAD_STOCK_LABELS = CAD_STOCK_STATUS_ITEMS.reduce((acc, item) => {
  acc[item.id] = item.label;
  return acc;
}, {});

export const CAD_USE_LABELS = {
  residencial: 'Residencial',
  housing: 'Housing',
  corporativo: 'Corporativo',
  comercial: 'Comercial',
  amenity: 'Amenity',
  unknown: 'Sin clasificar',
};

/** Ancla del form de consulta en la ficha visitante (`/#/lista/:id`). */
export const CAD_INQUIRY_FORM_ID = 'cad-inquiry-form';

export const CAD_PARCEL_MAX_TITLE = 100;
export const CAD_PARCEL_MAX_DESC = 500;

/** Máximo de `name` (etiqueta del plano / chip) en `PATCH /updatecadparcel`. */
export const CAD_PARCEL_MAX_NAME = 80;

/** Máximo de `block` (manzana) en `PATCH /updatecadparcel`. */
export const CAD_PARCEL_MAX_BLOCK = 80;

/** Tope de `area_m2` en `PATCH /updatecadparcel`. */
export const CAD_PARCEL_AREA_M2_MAX = 1_000_000;

export const CAD_PARCEL_EDITABLE_KEYS = [
  'name',
  'title',
  'description',
  'use',
  'stock_status',
  'cad_kind',
  'price',
  'currency',
  'orientation',
  'position_label',
  'block',
  'fos',
  'fot',
  'area_m2',
];

/** Copy del editor de colección. Otro campo en el PATCH → 400. */
export const CAD_PARCEL_COLLECTION_EDITOR_KEYS = [
  'title',
  'description',
  'stock_status',
  'price',
  'currency',
  'area_m2',
  'block',
];
